import React from "react";
import { useNavigate } from "react-router-dom";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Button, Card, CardContent, CardHeader, Grid, InputAdornment, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";

import { Job } from "../../services/api";

const CreateJobForm: React.FC<{ newJob: Job; setNewJob: (job: Job) => void }> = ({ newJob, setNewJob }) => {
  let navigate = useNavigate();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setNewJob(new Job({ ...newJob, [name]: newJob.castToType(name, value) }));
  };

  const onSubmit = () => newJob.create().then((result) => navigate(`/jobs/${result.id}`));

  return (
    <Grid container>
      <Grid item sx={{ marginTop: "15pt" }} md={4} xs={12}>
        <Typography sx={{ fontSize: "20pt" }}>Create Job</Typography>
      </Grid>
      <Grid item md={true}>
        <Box sx={{ "& > :not(style)": { m: 1, width: "100%" } }}>
          {Object.entries(newJob.fieldsWithType()).map(([key, type]) => {
            const error = newJob.hasError(key);
            return (
              <TextField
                required
                name={key}
                key={key}
                type={type}
                label={key.replace(/_/g, " ")}
                variant="standard"
                autoComplete="off"
                error={!!error}
                helperText={error}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {error ? (
                        <ErrorIcon sx={{ color: "red" }} data-testid={`error-icon-${key}`} />
                      ) : (
                        <CheckCircleIcon sx={{ color: "green" }} data-testid={`valid-icon-${key}`} />
                      )}
                    </InputAdornment>
                  ),
                }}
                value={newJob[key as keyof Job] || ""}
                onChange={handleInputChange}
              />
            );
          })}
          <Card>
            <CardHeader title="Payload Preview" />
            <CardContent sx={{ bgcolor: "grey.800", color: "white" }}>
              <Typography component="code" sx={{ whiteSpace: "pre-wrap" }} data-testid={"payload-preview"}>
                {newJob.getUpsertXML()}
              </Typography>
            </CardContent>
          </Card>
          <Button
            variant="contained"
            sx={{ maxWidth: "100px" }}
            onClick={onSubmit}
            disabled={newJob.hasErrors()}
          >
            Submit
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};
export default CreateJobForm;
